import React from 'react'
import useFaceProfile from '../../shared/utils/useFaceProfile'
import DOMPurify from 'dompurify'
import './index.css'

const Welcome = props => {
  const { firstName } = useFaceProfile()
  return (
    <main aria-label='Content'>
      <div className='u-paddingVert8gu'>
        <div className='u-sizeConstrained'>
          <div className='Grid Grid--alignMiddle Grid--withGutter'>
            <div className='u-lg-sizeFull'>
              <div className='Content u-sm-marginBottom4gu u-md-marginBottom4gu'>
                <h1 className='u-textSecondary Type-Display u-textColorNeutral'>
                  <span className='FirstName'>{firstName ? firstName : ''}</span>
                  {firstName ? ', ' : ''}
                  {props.content.heading}
                </h1>
                <div
                  className='u-textSizeMsrp1'
                  dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(props.content.body) }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  )
}

export default Welcome
